import React, { Fragment } from 'react'
import { Field } from 'formular'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import { FormularField } from 'components/_new/forms'

import messages from './messages'


type DetailsProps = {
  titleField: Field<string>
  textField: Field<string>
}

const Details: React.FunctionComponent<DetailsProps> = ({ titleField, textField }) => {
  return (
    <Fragment>
      <Text size="18-24" semibold message={messages.title} />
      <Box mt={16}>
        <FormularField
          field={titleField}
          placeholder={messages.titlePlaceholder}
          standardView
          dataTestId="reviewTitle"
        />
      </Box>
      <Box mt={16}>
        <FormularField
          field={textField}
          placeholder={messages.textPlaceholder}
          standardView
          rows={5}
          autosize
          dataTestId="reviewText"
        />
      </Box>
    </Fragment>
  )
}


export default Details
